import { Typography } from "antd";
import { useParams } from "react-router-dom";
import { useTranslate } from "@refinedev/core";
import { Skeleton } from "@libertify/ui";
import { PlaybookAddOnCard } from "../../PlaybookAddOnCard";
import { CONFIG_ITEM } from "../../../data/addons";
import { StandoutsForm } from "./StandoutsForm";
import { useStandouts } from "./useStandouts";
import { KEY } from "./constants";

export type StandoutsEditCardProps = {
  visible?: boolean;
  onVisibleChange?: (visible: boolean) => void;
  visiblePending?: boolean;
};

/** Edit the generated Standouts of a published experience. */
export const StandoutsEditCard = ({
  visible,
  onVisibleChange,
  visiblePending,
}: StandoutsEditCardProps) => {
  const t = useTranslate();
  const { projectId = "" } = useParams<{ projectId: string }>();
  const { standouts, assetId, projectDocuments, isLoading, isError } =
    useStandouts(projectId);

  const renderBody = () => {
    if (isLoading) return <Skeleton variant="text" rows={6} />;
    if (isError) {
      return <Typography.Text type="danger">{t(`${KEY}.loadError`)}</Typography.Text>;
    }
    if (!assetId) {
      return <Typography.Text type="secondary">{t(`${KEY}.empty`)}</Typography.Text>;
    }
    // Keyed on the asset: a regenerated list is a new asset, and rows seeded
    // from the old one would be written over it.
    return (
      <StandoutsForm
        key={assetId}
        loaded={standouts}
        assetId={assetId}
        projectId={projectId}
        projectDocuments={projectDocuments}
      />
    );
  };

  return (
    <PlaybookAddOnCard
      itemId={CONFIG_ITEM.Standouts}
      title={t(`${KEY}.title`)}
      description={t(`${KEY}.subtitle`)}
      visible={visible}
      visiblePending={visiblePending}
      onVisibleChange={onVisibleChange}
    >
      {renderBody()}
    </PlaybookAddOnCard>
  );
};

export default StandoutsEditCard;
